import { render, staticRenderFns } from "./ChartInvestments.vue?vue&type=template&id=44fa637a"
import script from "./ChartInvestments.vue?vue&type=script&lang=js"
export * from "./ChartInvestments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports